import { render, staticRenderFns } from "./suitch-details-widget.vue?vue&type=template&id=4d0bde3a&"
import script from "./suitch-details-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-details-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports